import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { IAMCRequest, ITechnician } from '../../../utils/entities/interface';
import {
  capitalizeWords,
  formatBookingSlot,
  lockWidth,
} from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { ToggleTechnicianStatus } from '../../../services/technician';
import { SkeletonRows } from '../../skeletons/list';
import { DialogBoxComp } from '../../atoms/DialogBox';
import { ListTable } from '../../molecules/ListTable';
import { RemoveRedEyeOutlined } from '@mui/icons-material';

export const AmcRequests = ({
  requests,
  isLoading,
  onUpdate,
  tableCell = [],
  onManageClick,
}: {
  requests: IAMCRequest[];
  isLoading: boolean;
  onUpdate: () => void;
  tableCell?: any[];
  onManageClick: (id: string) => void;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const actions = [
    {
      icon: <RemoveRedEyeOutlined />,
      onClick: (row: any) => onManageClick(row._id),
    },
  ].filter(Boolean) as any[];

  const [selectedTechnician, setSelectedTechnician] =
    useState<ITechnician | null>(null);

  const handleClose = () => {
    setOpen(false);
    setSelectedTechnician(null);
  };

  const handleConfirm = async () => {
    if (selectedTechnician) {
      try {
        await ToggleTechnicianStatus(selectedTechnician._id);
        onUpdate();
        handleClose();
      } catch (error) {
        alert(
          error instanceof Error ? error.message : 'Failed to update status',
        );
      }
    }
  };

  return (
    <ListTable
      headerCells={tableCell}
      rows={requests}
      isLoading={isLoading}
      actions={actions}
      renderCell={(request: any, colIndex: number) => {
        switch (colIndex) {
          case 0:
            return request.leadId || '-';
          case 1:
            return capitalizeWords(request?.userDetails?.name) || 'N/A';
          case 2:
            return 'AMC';
          case 3:
            return capitalizeWords(request?.technicianName) || 'N/A';
          case 4:
            return `+91 - ${request?.userDetails?.phoneNumber || 'N/A'}`;
          case 5:
            return formatBookingSlot(
              request?.schedule?.date,
              request?.schedule?.slot,
            );
          case 6:
            return capitalizeWords(request?.enquiryStatus) || 'N/A';

          default:
            return null;
        }
      }}
    />
  );
};
